import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	DialogContentText,
	makeStyles,
	Grid,
	Typography,
	Button,
	useMediaQuery,
	useTheme,
	Divider
} from '@material-ui/core';

import ResponsiveDialog from "./ResponsiveDialog";
import Constants from '../utils/Constants';

const styles = makeStyles(theme => ({
	dialogPaper: {
		padding: "0px 20px 20px",
		borderRadius: '12px',
		width: '630px',
		[theme.breakpoints.down("sm")]: {
			minWidth: '100%',
			maxWidth: '100%'
		},
	},

	divider: {
		marginBottom: theme.spacing(2),
	},

	subtitle: {
		paddingBottom: theme.spacing(3),
		lineHeight: '28px',
		color: Constants.COLORS.SECONDARY.GREY,
		fontWeight: 600
	},

	cancelBtnItem: {
		padding: theme.spacing(1),
		border: `1px solid ${Constants.COLORS.SECONDARY.LIGHT_GREY}`,
		borderRadius: '8px',
	},
}));

function EscalationConfirmationDialog(props) {
	const theme = useTheme();
	const smaller = useMediaQuery(theme.breakpoints.down("sm"));

	let classes = styles(),
		{ open, closeHandler, submitHandler } = props;

	return (
		// <ResponsiveDialog
		// 	open={open}
		// 	maxWidth="sm"
		// 	title="You are about to escalate this alert to BCM"
		// 	content={content}
		// 	closeHandler={closeHandler}
		// />
		<Dialog
			open={open}
			onClose={closeHandler}
			maxWidth="sm"
			classes={{ paper: classes.dialogPaper }}>
			<DialogTitle>You are about to escalate this alert to BCM</DialogTitle>
			<DialogContent className={`${classes.content}`}>
				<DialogContentText>
					This alert will be marked as escalated, but no case number will be assigned until a case is created in BCM. Do you wish to continue?
				</DialogContentText>
			</DialogContent>
			<Divider className={classes.divider} />
			<DialogActions>
				<Button className={classes.cancelBtnItem} onClick={closeHandler}>Cancel</Button>
				<Button color="primary" variant='contained' onClick={submitHandler}>Yes, escalate the alert</Button>
			</DialogActions>
		</Dialog>
	);

}

EscalationConfirmationDialog.propTypes = {
	open: PropTypes.bool,
	closeHandler: PropTypes.func.isRequired,
	submitHandler: PropTypes.func.isRequired
};

export default EscalationConfirmationDialog;